import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Api from 'entities/helpers/api';
import TempTable from './ai-search-temp-table';
import Loading from 'components/elements/loading';

const gql = String.raw;
const EXECUTE_QUERY = gql`
  mutation ExecuteQueryMutation($query: String!) {
    executeQuery(input: { query: { query: $query, type: "natural_language_search" } }) {
      items
      total
      query {
        query
        id
        translations {
          id
          translation
          target
          version
        }
      }
      limit
      offset
      error
      warnings
    }
  }
`;

const AISearchNlsHome = ({ searchQuery }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalResults, setTotalResults] = useState(0);

  const executeGraphQLQuery = (query) => {
    return Api.SEARCH.GRAPHQL.post({
      data: JSON.stringify({
        query: String.raw`${EXECUTE_QUERY}`,
        variables: { query },
      }),
    });
  };

  useEffect(() => {
    if (searchQuery) {
      setLoading(true);
      executeGraphQLQuery(searchQuery)
        .then((response) => {
          if (response.errors) {
            throw new Error(response.errors[0].message);
          }
          if (!response.data) {
            throw new Error('No data found in response');
          }
          if (response.data.executeQuery) {
            const items = response.data.executeQuery?.items || [];
            const formattedData = items.map((item) => ({
              id: item.id,
              name: `${item.name_first} ${item.name_last}`,
            }));
            setData(formattedData);
            setTotalResults(response.data.executeQuery?.total || 0);
            setLoading(false);
          }
        })
        .catch((err) => {
          setError(err);
          console.error('Error occured while executing ExecuteQueryMutation: ', err);
          setLoading(false);
        });
    }
  }, [searchQuery]);

  if (error) return <p>Error: {error.message}</p>;

  const columns = [
    { header: 'ID', accessor: 'id' },
    { header: 'Name', accessor: 'name' },
  ];

  return (
    <div className="ai-search-container">
      {loading ? (
        <div className="loader-div">
          <Loading position="center" />
        </div>
      ) : (
        <>
          <div className="ai-search-header">
            <h1>AI Search Results for: </h1>
            <p>{searchQuery}</p>
          </div>
          <p>Total Results: {totalResults}</p>
          <TempTable data={data} columns={columns} />
        </>
      )}
    </div>
  );
};

AISearchNlsHome.propTypes = {
  searchQuery: PropTypes.string.isRequired,
};

export default AISearchNlsHome;
